// theme.js
import { createTheme } from "@mui/material/styles";

/**
 * Creates MUI theme with language-aware typography.
 * @param {string} direction - "ltr" for English, "rtl" for Dari/Pashto
 * @returns {object} MUI theme
 */
export const createAppTheme = (direction = "ltr") =>
  createTheme({
    direction: direction,
    typography: {
      fontFamily:
        direction === "rtl"
          ? "'Noto Sans Arabic', 'Noto Sans', sans-serif"
          : "'Roboto', 'Noto Sans', sans-serif",
    },
    palette: {
    primary: {
      main: "#176B87", // Custom primary color
    },
    secondary: {
      main: "#dc004e", // Custom secondary color
    },
    background: {
      default: "#faf7f7", // Background color
      paper: "#FFFFFF", // Paper background color
    },
    text: {
      primary: "#333333", // Primary text color
      secondary: "#666666", // Secondary text color
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "5px", // Custom border radius for buttons
          padding: "5px 10px", // Custom padding for buttons
          textTransform: "none", // Disable uppercase transformation
          "&:hover": {
            backgroundColor: "#1976d2", // Hover background color
            color: "#ffffff", // Hover text color
          },
        },
      },
    },
  },
  });

// Default export for backward compatibility
const theme = createAppTheme("ltr");
export default theme;
